import EstateCalculator from "@/components/EstateCalculator";

export default function EstateCalculatorPage() {
  return <EstateCalculator />;
}
